export const SET_CLINICIANS = 'SET_CLINICIANS'
export const ADD_CLINICIAN = 'ADD_CLINICIAN'
export const CLEAR_CLINICIANS = 'CLEAR_CLINICIANS'
export const SET_SELECTED_CLINICIAN = 'SET_SELECTED_CLINICIAN'
export const CLEAR_SELECTED_CLINICIAN = 'CLEAR_SELECTED_CLINICIAN'
export const RESET_CLINICIAN_STORE = 'RESET_CLINICIAN_STORE'
